/**
 * 契約企業情報のQuery Key Factory
 *
 * React Queryのキャッシュ管理に使用します。
 */
export const contractingCorporationProfileKey = {
  all: ['contractingCorporationProfile'] as const,
  detail: () => [...contractingCorporationProfileKey.all, 'detail'] as const
} as const;